// MapView.tsx
import React, { useEffect, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { Location, MapProps, MapWatchOptions, MapProvider } from './map.intf';


// 默认配置
// const defaultCenter = { lng: 116.402544, lat: 39.928216 };
// const defaultZoom = 10;
// const defaultWatchOptions = {
//   enableHighAccuracy: true,
//   timeout: 5000,
//   maximumAge: 0
// };

// // 使用 dynamic 导入地图组件，并禁用 SSR
// const MapWithLoader = dynamic<MapProps>(
//   () => import('react-bmapgl').then((mod) => {
//     const { Map, MapApiLoaderHOC } = mod;
    
//     // 创建一个函数式组件
//     const MapComponent: React.FC<MapProps> = (props) => {
//       const {
//         center = defaultCenter,
//         zoom = defaultZoom,
//         onLocationUpdate,
//         onLocationError,
//         watchPosition = false,
//         watchOptions = defaultWatchOptions,
//         onCenterChange,
//         ...restProps
//       } = props;
      
//       const mapRef = useRef<any>(null);
//       const geolocationRef = useRef<any>(null);
//       const watchIdRef = useRef<number | null>(null);
//       // 新增：本地中心点state
//       const [currentCenter, setCurrentCenter] = useState<Location>(center);
//       const [hasLocated, setHasLocated] = useState(false);

//       // 只在初次定位后设置地图中心
//       useEffect(() => {
//         console.log('hasLocated=',hasLocated);
//         console.log('navigator.geolocation=',navigator.geolocation);
//         if (!hasLocated && navigator.geolocation) {
//           navigator.geolocation.getCurrentPosition(
//             (pos) => {
//               const location = {
//                 lng: pos.coords.longitude,
//                 lat: pos.coords.latitude,
//                 accuracy: pos.coords.accuracy,
//                 timestamp: pos.timestamp || Date.now()
//               };
//               console.log('location=',location);
//               setCurrentCenter(location);
//               setHasLocated(true);
//               onLocationUpdate?.(location);
//             },
//             (err) => {
//               setHasLocated(true); // 不再尝试
//               onLocationError?.(err);
//             }
//           );
//         }
//       }, [hasLocated, onLocationUpdate, onLocationError]);

//       // 获取当前位置（仅watchPosition时回调，不再设置中心）
//       const getCurrentPosition = () => {
//         if (!geolocationRef.current) return;
//         geolocationRef.current.getCurrentPosition(
//           (position: any) => {
//             if (position?.point) {
//               const location = {
//                 lng: position.point.lng,
//                 lat: position.point.lat,
//                 accuracy: position.accuracy,
//                 timestamp: position.timestamp || Date.now()
//               };
//               onLocationUpdate?.(location);
//             }
//           },
//           (error: any) => {
//             onLocationError?.(error);
//           },
//           watchOptions
//         );
//       };

//       // 监听位置变化（只回调，不设置中心）
//       const startWatchingPosition = () => {
//         if (!geolocationRef.current || !watchPosition) return;
//         getCurrentPosition();
//         watchIdRef.current = window.setInterval(() => {
//           getCurrentPosition();
//         }, watchOptions.timeout || 5000);
//       };
//       const stopWatchingPosition = () => {
//         if (watchIdRef.current) {
//           clearInterval(watchIdRef.current);
//           watchIdRef.current = null;
//         }
//       };

//       // 初始化地图和地理位置
//       const initMap = (map: any) => {
//         if (!map) return;
//         mapRef.current = map;
//         try {
//           geolocationRef.current = new BMapGL.Geolocation();
//           // 修正：获取真实地图实例
//           const realMap = map.map || map.instance;
//           if (realMap) {
//             if (realMap.enableScrollWheelZoom) realMap.enableScrollWheelZoom(true);
//             if (realMap.enableContinuousZoom) realMap.enableContinuousZoom();
//             if (realMap.enableInertialDragging) realMap.enableInertialDragging();
//           }
//           if (onCenterChange) {
//             (realMap || map).addEventListener('moveend', () => {
//               const c = (realMap || map).getCenter();
//               console.log('c=',c);
//               onCenterChange({ lng: c.lng, lat: c.lat });
//             });
//           }
//           if (watchPosition) {
//             startWatchingPosition();
//           }
//         } catch (error) {
//           onLocationError?.(error);
//         }
//       };

//       useEffect(() => {
//         return () => {
//           stopWatchingPosition();
//         };
//       }, []);
//       useEffect(() => {
//         if (watchPosition) {
//           startWatchingPosition();
//         } else {
//           stopWatchingPosition();
//         }
//         return () => {
//           stopWatchingPosition();
//         };
//       }, [watchPosition]);

//       return (
//         <Map
//           ref={initMap}
//           style={{ height: '100%', width: '100%', ...restProps.style }}
//           center={new BMapGL.Point(currentCenter.lng, currentCenter.lat)}
//           zoom={zoom}
//           {...restProps}
//         />
//       );
//     };

//     // 使用类型断言来避免类型错误
//     return MapApiLoaderHOC({
//       ak: 'MmweUMZxcXOThZUaBuQ2rtKwLNHf1Hix'
//     })(MapComponent as any) as any;
//   }), 
//   { 
//     ssr: false,
//     loading: () => (
//       <div style={{ 
//         height: '100%', 
//         width: '100%', 
//         display: 'flex', 
//         alignItems: 'center', 
//         justifyContent: 'center',
//         backgroundColor: '#f5f5f5',
//         color: '#666'
//       }}>
//         地图加载中...
//       </div>
//     )
//   }
// );

// 动态导入各地图实现
const BaiduMapView = dynamic(() => import('./BaiduMapView').then(m => m.BaiduMapView), { ssr: false });
const GoogleMapView = dynamic(() => import('./GoogleMapView').then(m => m.GoogleMapView), { ssr: false });
const AmapMapView = dynamic(() => import('./AmapMapView').then(m => m.AmapMapView), { ssr: false });

export const MapView: React.FC<MapProps> = (props) => {
  const { provider = MapProvider.Baidu, ...rest } = props;
  if (provider === MapProvider.Google) {
    return <GoogleMapView {...rest} />;
  }
  if (provider === MapProvider.Amap) {
    return <AmapMapView {...rest} />;
  }
  return <BaiduMapView {...rest} />;
};
